import React, { useMemo } from 'react';
import { Form, FormProps, Input, Select } from 'antd';
import { FooterWrapper } from '@src/emp-3.0/components/MappedEventBuilder/Footer/styled';
import { validateMappedEventName } from '@src/emp-3.0/domain/mapped-event';
import { useGetEventCategory } from '@api/emp/queryHooks';

const Footer = ({
  form,
  onValidate,
  eventNameError,
  ...rest
}: FormProps & { eventNameError?: boolean; onValidate: (value) => void }) => {
  const { data: categoryData } = useGetEventCategory();
  const categoryItems = useMemo(() => {
    return categoryData?.data?.map((v) => {
      return { label: v.category_name, value: v.category_name };
    });
  }, [categoryData]);

  return (
    <Form form={form} {...rest} style={{ width: '100%' }}>
      <FooterWrapper>
        <Form.Item
          name={'event_name'}
          style={{ flex: 1 }}
          label={
            <div>
              Name <span style={{ color: '#ff4d4f' }}></span>
            </div>
          }
          required={false}
          validateStatus={eventNameError ? 'error' : undefined}
          rules={[
            () => ({
              validator(_, value) {
                const { failed, message } = validateMappedEventName(value);
                if (failed) {
                  onValidate({ failed: true, field: 'event_name', message });
                  return Promise.reject(message);
                }
                onValidate({ failed: false, field: 'event_name' });
                return Promise.resolve();
              },
            }),
          ]}
        >
          <Input />
        </Form.Item>
      </FooterWrapper>
    </Form>
  );
};

export default Footer;
